module.exports = __webpack_public_path__ + "static/media/ToiLogo.c6809710.jpg";